import React from "react";

export default function Sidebaradmin() {
  return (
    <div className="sticky top-0 flex flex-col md:flex-row min-h-screen bg-white">
      <aside className="w-full md:w-64 bg-gray-800 text-white p-4">
        <h1 className="text-2xl font-bold">Admin Panel</h1>
        <ul className="mt-4">
          <li className="mb-2">
            <a href="/admin" className="text-gray-300 hover:text-white">
              Dashboard
            </a>
          </li>
          <li className="mb-2">
            <a href="/admin/user" className="text-gray-300 hover:text-white">
              Users
            </a>
          </li>
          <li className="mb-2">
            <a href="/admin/practice" className="text-gray-300 hover:text-white">
              Questions
            </a>
          </li>
          <li className="mb-2">
            <a href="/admin/post" className="text-gray-300 hover:text-white">
              Post
            </a>
          </li>
          <li className="mb-2">
            <a href="/admin/product" className="text-gray-300 hover:text-white">
              Products
            </a>
          </li>
          <li className="mb-2">
            <a href="/admin/product/price" className="text-gray-300 hover:text-white">
              Dynamic Price
            </a>
          </li>
          {/* Add more sidebar items as needed */}
        </ul>
      </aside>
    </div>
  );
}
